import api from './api'

const moderationService = {
  reportMessage: (messageId, reason) => api.post('/moderation/reports', { messageId, reason }),
  // Admin
  adminGetReports: (status) => api.get('/moderation/admin/reports', { params: { status } }),
  adminUpdateReport: (id, data) => api.patch(`/moderation/admin/reports/${id}`, data)
}

export default moderationService
